module.exports = __webpack_public_path__ + "img/buddy_whiskers-01.c5b78d25.svg";